module.exports = __webpack_public_path__ + "assets/akka-http.722e3f81.svg";